import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Multitenant } from '../../services/multitenant.provider';
import { AuthProvider } from '../../services/auth.provider';
import { StorageProvider } from '../../services/storage.provider';
import { MetaProvider } from '../../services/meta.provider';
import { PopUp } from '../../models/popup.model';
import { PopUpService } from '../../shared/components/pop-up/pop-up.service';

@Component({
  selector: 'app-archives',
  templateUrl: 'archives.html',
  styleUrls: ['archives.scss']
})
export class ArchivesPage {
  public themeClass: string;
  public authenticated: boolean;
  public newspapers: Array<any>;
  public profileId: string;
  public isActivePage: string;
  public tempPopUp: boolean;
  public popup: PopUp = new PopUp();

  constructor(
    private router: Router,
    private multiTenant: Multitenant,
    private auth: AuthProvider,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private popUpService: PopUpService
  ) {}

  ionViewWillEnter() {
    let news: Array<any>;
    const newspapers: Array<any> = [];
    this.themeClass = this.multiTenant.getDomainClass();
    this.authenticated = this.auth.isAuthenticated();
    if (this.auth.isAuthenticated() && this.auth.hasAccessTo()) {
      news = this.auth.hasAccessTo().split(',');
    }

    if (!this.auth.isAuthenticated()) {
      news = ['lepq', 'mquo', 'actu', 'aeco'];
    }

    if (news) {
      news.forEach((item, index) => {
        if (item === 'lepq') {
          newspapers.push({ class: 'lepq', age: 'Pour les 7-10 ans' });
        }
        if (item === 'mquo') {
          newspapers.push({ class: 'mquo', age: 'Pour les 10-13 ans' });
        }
        if (item === 'actu') {
          newspapers.push({ class: 'actu', age: 'Pour les 13-20 ans' });
        }
        if (item === 'aeco') {
          newspapers.push({ class: 'aeco', age: 'Pour les 15-20 ans' });
        }
      });
    }

    this.newspapers = newspapers;
  }

  ionViewDidEnter() {
    if (this.storage.getStorage('logged_profile_id')) {
      this.profileId = this.storage.getStorage('logged_profile_id');
    }
    this.isActivePage = 'archives';
    this.meta.clearHead();

    if (
      !this.auth.isAuthenticated() &&
      this.popUpService.havePassedSevenDays() &&
      this.multiTenant.getDomainClass() === 'playbacpresse'
    ) {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  goToArchivesSite() {
    window.open('http://archives.playbacpresse.fr/?token=78372' + this.profileId + '93287', '_blank');
  }

  goToNewsPapers() {
    this.router.navigate(['pdf', 'choisir-un-titre']);
  }
}
